// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_2msLL2MTS1-Ij_3EjIDWN-_0","large-player":"_1U10boKSsg9StWHMW8mWCB_0","player":"_1YUO_hV5QcB8MDtrSYyVdQ_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"id":2,"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0ce5111b","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"strictMath":"on","sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src.common/ui/players/list.vue
// module id = 195
// module chunks = 0